import { createApp } from 'vue'
import { isLogin } from '~/js/templates/index/helpers'
import { ProductListService } from '~/js/services/productListService'
const CLASS_NAME_PRODUCT_ADD_PRODUCT_LIST = 'js-productAddProductList'

document.addEventListener('DOMContentLoaded', () => {
  const elementsProductAddProductList = document.getElementsByClassName(
    CLASS_NAME_PRODUCT_ADD_PRODUCT_LIST
  )
  if (!elementsProductAddProductList.length) return
  const productListService = new ProductListService()

  Array.from(elementsProductAddProductList).forEach(async (element) => {
    const productId = Number(element.dataset.productId)

    let isProductAdded = false
    try {
      const { wishlists } = await productListService.getWishLists()
      isProductAdded =
        wishlists &&
        wishlists.length &&
        wishlists[0].productIds.includes(productId)
      // eslint-disable-next-line no-empty
    } catch (_) {}

    createApp({
      name: 'TemplatesProductProductList',
      data() {
        return {
          isProcessing: false,
          isProductAdded,
          showWishlistModal: false,
        }
      },
      computed: {
        text() {
          return this.isProductAdded
            ? 'ほしいものリストに追加済み'
            : 'ほしいものリストに追加する'
        },
      },
      methods: {
        async onClick() {
          if (this.isProductAdded || this.isProcessing) return
          if (!isLogin) {
            window.dispatchEvent(
              new CustomEvent('button-login-required-clicked', {
                detail: { text: 'ほしいものリストに追加するには<br>' },
              })
            )
            return
          }

          this.isProcessing = true
          try {
            await productListService.addProduct({ productId })
            this.isProductAdded = true
          } catch (error) {
            console.error(error)
          }
          this.isProcessing = false
        },
      },
    }).mount(element)
  })
})
